import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ConditionBox from './ConditionBox';

import { MobileTabletOnly, DesktopUp } from 'shared/Responsive';

import ArrowIcon from 'images/ask/icons/arrow-01.svg';
import SectionBottomImage from 'images/ask/section-bottom-01.svg';

const SupportedConditions = ({title, conditions}) => {
  const healthAZLinkHeaderLink = () => (
    <div className="supported-conditions__header__link">
      <Link to="/health">
        <span>See all supported conditions</span>
        <img src={ArrowIcon} />
      </Link>
    </div>
  );

  return (
    <section className="supported-conditions">
      <div className="container">
        <div className="supported-conditions__header">
          <div className="supported-conditions__header__top">
            <div className="supported-conditions__header__title">
              <h3>{title}</h3>
            </div>

            <DesktopUp>
              { healthAZLinkHeaderLink() }
            </DesktopUp>
          </div>
          <p>
            We can detect thousands of skin conditions and symptoms, from the common to the complex with the snap of a photo. Here are some of the common conditions we support:
          </p>

          <MobileTabletOnly>
            { healthAZLinkHeaderLink() }
          </MobileTabletOnly>
        </div>
        <div className="supported-conditions__content">
          {
            conditions.map(condition => <ConditionBox key={condition} name={condition} />)
          }
        </div>

        {/*
        <Link to="/health" className="supported-conditions__health-link link-with-icon">
          <span>See all supported conditions</span>
          <img src={ArrowIcon} />
        </Link>
        */}
      </div>
      <img src={SectionBottomImage} />
    </section>
  );
};

SupportedConditions.propTypes = {
  title: PropTypes.string.isRequired,
  conditions: PropTypes.array.isRequired
};

export default SupportedConditions;
